import { type VariantProps, cva } from 'class-variance-authority';
import type { ReactNode, SVGAttributes, JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '../../types';

export interface IconProps
    extends CommonProps,
        VariantProps<typeof IconStyles> {
    viewBox?: SVGAttributes<SVGSVGElement>['viewBox'];
    children?: ReactNode;
}

export const IconStyles = cva('inline-block fill-current', {
    variants: {
        size: {
            auto: 'w-auto',
            xl: 'w-8 h-8',
            lg: 'w-6 h-6',
            md: 'w-4 h-4',
            sm: 'w-3 h-3',
            xs: 'w-2.5 h-2.5',
            xxs: 'w-2 h-2',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});

export const Icon = ({
    viewBox = '0 0 24 24',
    size,
    className,
    children,
    testId = 'icon',
    ...props
}: IconProps): JSX.Element => {
    return (
        <svg
            className={twMerge(IconStyles({ size, className }))}
            data-testid={testId}
            viewBox={viewBox}
            {...props}
        >
            {children}
        </svg>
    );
};
